import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Browser from '@wetransfer/concorde-browser';

import FileSystemEntry from './file-system-entry';

import I18n from '@module/i18n';

import Helper from '@app/helper';
import Preview from '@app/page/transfer/preview';

export const File = ({
  action,
  active,
  altText,
  file,
  onClick,
  route,
  showPending,
}) => {
  const title = file.name || file.safename;
  const details = [
    altText && showPending ? altText : I18n.size(file.size, { precision: 0 }),
  ];
  const extension = Helper.getFileExtension(title);

  if (extension) {
    details.push(extension);
  }
  if (Browser.isMobile && file.previewable) {
    const key = active
      ? 'transfer.preview.now_open'
      : 'transfer.preview.tap_to_open';
    details.push(I18n.t(key));
  }

  const className = active ? 'filelist__item--previewing' : '';

  return (
    <FileSystemEntry
      title={title}
      details={details}
      actions={action}
      className={className}
      onClick={onClick}
    >
      {active && Browser.isMobile ? <Preview route={route} /> : null}
    </FileSystemEntry>
  );
};

File.propTypes = {
  file: PropTypes.object.isRequired,
  action: PropTypes.node,
  showPending: PropTypes.bool,
  altText: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  route: PropTypes.object,
};

const mapStateToProps = ({ route }) => ({ route });

export default connect(
  mapStateToProps,
  null
)(File);
